import styled from 'styled-components'
import numeral from 'numeral'

const Price = styled.div.attrs(({ amount }) => ({
  children: amount ? numeral(amount).format('$0,0+') : 'Contact',
}))`
  font-size: 1.2em;
`

export default Price
